import { networkCreateLink } from "@/modules/api/resourceCreateLinks.ts";
import { Navigate, createFileRoute } from "@tanstack/react-router";

/** @deprecated Legacy route redirect, should not be used in new code */
export const Route = createFileRoute("/_main/network/create/")({
    component: () => <Navigate {...networkCreateLink} replace />,
});
